import React from "react";
import { Show, SimpleShowLayout, TextField } from "react-admin";

const DistrictShow = (props) => {
  return (
    <div>
      <Show {...props}>
        <SimpleShowLayout>
          <TextField source="id" />
          <TextField source="seasonCode" />
          <TextField source="sportCode" />
          <TextField source="leagueCode" />
          <TextField source="conferenceCode" />
          <TextField source="divisionCode" />
          <TextField source="regionCode" />
          <TextField source="districtCode" />
          <TextField source="label" />
        </SimpleShowLayout>
      </Show>
    </div>
  );
};

export default DistrictShow;
